<div class="tile">
  <ep-product-portrait-tile-info
    [product]="product"
    [hasAddToListButton]="hasAddToListButton"
    [hasDeleteButton]="hasDeleteButton"
    [displayPriceOnHover]="displayPriceOnHover"
    (onClickDeleteButton)="onClickDeleteButton.emit($event)"
    (onClick)="onClick.next($event)"
  ></ep-product-portrait-tile-info>
  <ep-add-to-cart-button *ngIf="hasAddToCartButton" [product]="product"></ep-add-to-cart-button>
  <app-add-remove-pdf-button *ngIf="hasAddToPdfButton" [product]="product"></app-add-remove-pdf-button>
</div>
